import { HistoryStack, HistoryStackEntry } from '../../state';

export const createGetCurrentHistoryStackEntrySelector = <S, N extends string>(
  getHistoryStackState: (state: S) => HistoryStack<N>,
): ((state: S) => HistoryStackEntry<N> | null) => (
  state: S,
): HistoryStackEntry<N> | null => {
  const stack = getHistoryStackState(state);
  const entry = stack.entries[stack.index] || null;
  return entry as HistoryStackEntry<N> | null;
};
